import { createStore } from 'vuex'
import {moduleA} from "./modules/moduleA/moduleA.store"

export default createStore({
  state: {
    dialog:false,
    alartDialog:false,
    subDialog: {visible:false, data:null}
  },
  mutations: {
    setDialog(state, val){
      state.dialog = val
    },
    setSubDialog(state, val){
      state.subDialog = val
    },
    setAlartDialog(state, val){
      state.alartDialog = val
    },
  },
  modules: {
    moduleA: moduleA
  }
})
